import React from "react";
import bulbIcon from "../../../images/new-images/bulb-orange.svg";
import checkIcon from "../../../images/new-images/check-green.svg";
import calenderIcon from "../../../images/new-images/calender-blue.svg";

const Dashboardcard = (props) => {
  const getCardIcon = () => {
    if (props.type === "new_assessment") {
      return bulbIcon;
    } else if (props.type === "completed") {
      return checkIcon;
    } else if (props.type === "invitations") {
      return calenderIcon;
    }
    return null;
  };
  const getCardHeader = () => {
    if (props.type === "new_assessment") {
      return "New Assessments";
    } else if (props.type === "completed") {
      return "Completed Assessments";
    } else if (props.type === "invitations") {
      return "My Invitations";
    }
    return null;
  };
  const getCardColor = () => {
    if (props.type === "new_assessment") {
      return "orange";
    } else if (props.type === "completed") {
      return "green";
    } else if (props.type === "invitations") {
      return "dark-blue";
    }
    return null;
  };
  const getCardStatus = () => {
    if (props.type === "new_assessment") {
      return props.pendingAssessment + " Pending Assessment,";
    } else if (props.type === "completed") {
      return "Ready to view";
    } else if (props.type === "invitations") {
      return props.invitations + " Respondants";
    }
    return null;
  };
  const expiredCardStatus = () => {
    if (props.type === "new_assessment") {
      return props.expiredAssessment + " Expired Assessment";
    }
  };

  return (
    <div className="flex-column">
      <img src={getCardIcon()} alt="Card Icons" />
      <div className="item-divider">
        <h1>{getCardHeader()}</h1>
        <span className={getCardColor()}>{props.count}</span>
      </div>
      <div className="card-status-wrapper">
        <p>
          <span>{getCardStatus()}</span>
          <span>{expiredCardStatus()}</span>
        </p>
      </div>
    </div>
  );
};

export default Dashboardcard;



// WEBPACK FOOTER //
// ./src/new/Dashboard/Dashboard-summary/dashboard-summary-card.jsx